import makeStyles from '@material-ui/core/styles/makeStyles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

const dealerSelectStyles = makeStyles<ISpcTheme>(subaruTheme => ({
  inputContainer: {
    fontSize: subaruTheme.typography.pxToRem(subaruTheme.typography.fontMD),
    fontFamily: subaruTheme.typography.fontFamily,
    marginTop: '3rem',
    padding: '1rem',
    backgroundColor: subaruTheme.palette.primary.main,
    color: subaruTheme.palette.primary.contrastText,
    fontWeight: 'bold',
  },
  actionButton: {
    float: 'right',
    color: subaruTheme.palette.common.white,
    display: 'flex',
    left: '.5rem',
    marginRight: '1rem',
    opacity: 'inherit',
    border: `1px solid ${subaruTheme.palette.common.white}`,
    '& span > span': {
      top: '1px',
      right: '-1px',
    },
  },
  buttonLabel: {
    float: 'right',
    opacity: 'inherit',
    '&:hover': {
      opacity: 'inherit',
    },
  },
}));

export default dealerSelectStyles;
